<template>
  <div
    class="retail_add_order_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="$t('Please wait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="custom_breadcrumb_label_wrap flex-between">
      <div class="custom_breadcrumb flex-rowl">
        <p>Home</p>
        <span class="iconfont icon-arrow"></span>
        <p>Clothes</p>
        <span class="iconfont icon-arrow"></span>
        <p>Men's Clothing & Accessories</p>
      </div>
      <div class="label_wrap flex-rowr">
        <p class="label_icon"></p>
        <div class="label_list flex-rowl">
          <div class="label_item"># Hoodie</div>
          <div class="label_item"># T-Shirt</div>
        </div>
        <div class="label_btn flex-rowl" @click="handleLabelMore">
          More Tags <i class="iconfont"></i>
        </div>

        <!-- 跟多标签 -->
        <!-- 使用 <transition> 组件添加过渡动画 -->
        <transition name="slide">
          <div
            class="more_label_wrap_expanded flex-rowl"
            v-if="showAllLabels"
            @mouseleave="handleMouseLeave"
          >
            <div class="more_label_list flex-rowl">
              <div class="more_label_item"># Hoodie</div>
              <div class="more_label_item"># T-Shirt</div>
              <div class="more_label_item"># T-Shirt</div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="main_container">
      <!-- 内容展示 -->
      <div class="content_container flex-rowl">
        <div class="shop_info_container">
          <div class="shop_info_banner">
            <div class="shop_info_banner_list">
              <div
                class="shop_info_banner_item"
                v-for="(item, index) in bannerList"
                :key="index"
                :class="{ active: currentBannerIndex === index }"
                @click="currentBannerIndex = index"
              >
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item"
                  fit="cover"
                ></el-image>
              </div>
            </div>
            <div class="shop_info_banner_box">
              <el-image
                style="width: 100%; height: 100%"
                :src="bannerList[currentBannerIndex]"
                fit="cover"
              >
              </el-image>
            </div>
            <!-- 下载、放大功能 -->
            <div class="shop_info_banner_operation flex-rowl">
              <span
                class="icon-xiazai"
                @click="downloadImage(bannerList[currentBannerIndex])"
              ></span>
              <div class="kuaijin-box">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="require('@/assets/images/icon-kuaijin.png')"
                  fit="cover"
                  :preview-src-list="[bannerList[currentBannerIndex]]"
                >
                </el-image>
              </div>
            </div>
          </div>
          <div class="shop_info_btn flex-rowc">Product details</div>
        </div>
        <div class="order_info_container">
          <h1>{{ commodityDetail.mul_commodityname }}</h1>
          <div class="label_list flex-rowl">
            <div
              class="label_item"
              v-for="(item, index) in commodityDetail.labelslist"
              :key="index"
            >
              # {{ item.mul_labelcont }}
            </div>
          </div>
          <div class="txt">{{ commodityDetail.mul_shortname }}</div>
          <!-- 整体订单物流信息 -->
          <div class="order_info_wrap">
            <div class="order_data_tit">Delivery information：</div>
            <div class="order_info_content" v-if="selectedOrderLogistics.id">
              <div class="order_info_head flex-between">
                <p>
                  {{
                    currentLogisticsType == "receiving_info"
                      ? "Send to Designated Recipient"
                      : "Send to Warehouse"
                  }}
                </p>
                <div class="operation_wrap flex-rowr">
                  <i
                    class="iconfont icon-xiugai"
                    @click="handleEditLogistics"
                  ></i>
                  <i
                    class="iconfont icon-close"
                    @click="handleDelLogistics"
                  ></i>
                </div>
              </div>
              <div class="order_info_body">
                <h2 v-if="currentLogisticsType == 'receiving_info'">
                  {{ selectedOrderLogistics.truename }}
                </h2>
                <h2 v-else>{{ selectedOrderLogistics.mul_whname }}</h2>
                <p>
                  <span v-if="selectedOrderLogistics.countryidsstr"
                    >{{ selectedOrderLogistics.countryidsstr }}、</span
                  >
                  <span v-if="selectedOrderLogistics.province"
                    >{{ selectedOrderLogistics.province }}、</span
                  >
                  <span v-if="selectedOrderLogistics.city"
                    >{{ selectedOrderLogistics.city }}、</span
                  >
                  <span v-if="selectedOrderLogistics.area">{{
                    selectedOrderLogistics.area
                  }}</span>
                </p>
                <p>{{ selectedOrderLogistics.addr }}</p>
              </div>
            </div>
            <div
              class="order_no_data_wrap flex-rowc"
              v-else
              @click="handleShowPopup(1)"
            >
              <i class="iconfont icon-jiahao1"></i>
            </div>
          </div>

          <!-- 订单商品 -->
          <div class="order_shop_wrap">
            <div class="order_data_tit">Add Products：</div>
            <div
              class="order_shop_content_list"
              v-if="selectedOrderAttrList.length > 0"
            >
              <div
                class="order_shop_content_item"
                v-for="(item, index) in selectedOrderAttrList"
                :key="index"
              >
                <div class="order_shop_head flex-between">
                  <div class="order_shop_attr_num flex-rowl">
                    <p
                      v-for="(
                        itemAttrVal, indexAttrVal
                      ) in item.newAttrValueArr"
                      :key="indexAttrVal"
                    >
                      {{ itemAttrVal }},
                    </p>
                    <p>{{ item.num }}</p>
                  </div>
                  <div class="operation_wrap flex-rowr">
                    <i
                      class="iconfont icon-xiugai"
                      @click="handleShowPopup(2, item)"
                    ></i>
                    <i
                      class="iconfont icon-close"
                      @click="handleDelOrderItem(item)"
                    ></i>
                  </div>
                </div>
                <div class="order_shop_body" v-if="item.receivingObj">
                  <div class="name_tel flex-rowl">
                    <h2>{{ item.receivingObj.truename }}</h2>
                    <p>
                      {{ item.receivingObj.mobile }}
                    </p>
                  </div>
                  <p>
                    <span v-if="item.receivingObj.country">{{
                      item.receivingObj.country
                    }}</span>
                    <span v-if="item.receivingObj.province">{{
                      item.receivingObj.province
                    }}</span>
                    <span v-if="item.receivingObj.city">{{
                      item.receivingObj.city
                    }}</span>
                    <span v-if="item.receivingObj.addr">{{
                      item.receivingObj.addr
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="order_no_data_wrap flex-rowc"
              @click="handleShowPopup(2)"
            >
              <i class="iconfont icon-jiahao1"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 内容详情 start -->
      <div class="content_detail">
        <div class="content_detail_list" v-if="detailContent.length > 0">
          <div
            class="content_detail_item"
            v-for="(item, index) in detailContent"
            :key="index"
          >
            <!-- 图片 -->
            <template v-if="item.conttype == 1">
              <div class="pic_box">
                <img :src="item.picurl" alt="" />
              </div>
            </template>

            <!-- 视频 -->
            <template v-if="item.conttype == 2">
              <div class="video_box">
                <video :src="item.videourl" controls></video>
              </div>
            </template>

            <!-- 文本 -->
            <template v-if="item.conttype == 3">
              <div class="txt_box">{{ item.details }}</div>
            </template>
          </div>
        </div>
        <el-empty description="暂无内容" v-else></el-empty>
      </div>
    </div>

    <!-- 订单计算 -->
    <div class="btm_container flex-between">
      <div class="left_btm flex-rowl">
        <div class="left_btm_item flex-rowl">
          <p class="txt mr_10">Quantity Ordered:</p>
          <p class="num">{{ totalNum }}</p>
        </div>
        <div class="left_btm_item flex-rowl">
          <p class="txt mr_20">Price Status:</p>
          <p class="unit mr_10">({{ COUNTRY.moneyslog }})</p>
          <p class="num" v-html="mul_currentPrice"></p>
          <span class="line">/</span>
          <p class="txt">Per piece</p>
        </div>
      </div>
      <div class="right_btm flex-rowr">
        <div class="right_btm_item flex-rowl">
          <p class="txt b mr_20">Total Prices:</p>
          <p class="unit mr_10">({{ COUNTRY.moneyslog }})</p>
          <p class="num" v-html="mul_totalPrice_str"></p>
        </div>
        <div
          class="right_btm_btn flex-rowc"
          :class="{
            disabled:
              totalNum == 0 ||
              selectedOrderAttrList.length == 0 ||
              !selectedOrderLogistics.id,
          }"
          @click="submitOrder"
        >
          Confirm <i class="iconfont icon-yuyinjiantou"></i>
        </div>
      </div>
    </div>
    <!-- 物流信息 -->
    <div class="custom_dialog custom_dialog_address" v-show="isLogistics">
      <div class="custom_dialog_container">
        <div class="custom_dialog_close" @click="isLogistics = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
        <div class="custom_dialog_head flex-rowl">
          <div
            class="custom_dialog_tit"
            :class="{ active: activeName == 'first' }"
            @click="handleTabClick('first')"
          >
            {{ $t("ShipToMyWarehouse") }}
          </div>
          <span class="line">|</span>
          <div
            class="custom_dialog_tit"
            :class="{ active: activeName == 'second' }"
            @click="handleTabClick('second')"
          >
            {{ $t("ShipToDesignatedRecipient") }}
          </div>
        </div>
        <div class="custom_dialog_body">
          <div
            class="address_dialog_body"
            v-loading="customLoading"
            :element-loading-text="$t('Please wait')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            v-if="activeName == 'first'"
          >
            <div
              class="address_list"
              v-if="!customLoading && warehouseList.length > 0"
            >
              <div
                v-for="(item, index) in warehouseList"
                :key="index"
                @click="handleLogisticsItem('warehouse_info', item)"
                class="address_item flex-rowl"
                :class="{ active: item.id == selectedOrderLogistics.id }"
              >
                <div class="radio flex-rowl">
                  <span
                    class="iconfont"
                    :class="
                      item.id == selectedOrderLogistics.id
                        ? 'icon-danxuanyixuan1'
                        : 'icon-quanxuan'
                    "
                  ></span>
                </div>
                <div class="address_content flex-rowl">
                  <div class="address_content_item">
                    <h1>
                      {{ item.mul_whname }}
                    </h1>
                    <p>
                      <span>{{ item.countryidsstr }}、</span>
                      <span>{{ item.city }}、</span>
                      <span>{{ item.area }}</span>
                    </p>
                    <p>{{ item.addr }}</p>
                  </div>
                </div>
              </div>
            </div>
            <el-empty
              :description="$t('NoData')"
              v-if="!customLoading && warehouseList.length == 0"
            ></el-empty>
          </div>

          <div
            class="address_dialog_body"
            v-loading="customLoading"
            :element-loading-text="$t('Please wait')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            v-if="activeName == 'second'"
          >
            <div
              class="address_list"
              v-if="!customLoading && receivingList.length > 0"
            >
              <div
                v-for="(item, index) in receivingList"
                :key="index"
                @click="handleLogisticsItem('receiving_info', item)"
                class="address_item flex-rowl"
                :class="{
                  active: item.id == selectedOrderLogistics.id,
                }"
              >
                <div class="radio flex-rowl">
                  <span
                    class="iconfont"
                    :class="
                      item.id == selectedOrderLogistics.id
                        ? 'icon-danxuanyixuan1'
                        : 'icon-quanxuan'
                    "
                  ></span>
                </div>
                <div class="address_content flex-rowl">
                  <div class="address_content_item">
                    <h1>{{ item.truename }}</h1>
                    <p>{{ item.mobile }}</p>
                    <p>
                      <span>{{ item.province }}、</span>
                      <span>{{ item.city }}、</span>
                      <span>{{ item.area }}</span>
                    </p>
                  </div>
                  <div class="address_content_item">
                    <p>{{ item.addr }}</p>
                  </div>
                </div>
              </div>
            </div>
            <el-empty
              :description="$t('NoData')"
              v-if="!customLoading && receivingList.length == 0"
            ></el-empty>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品属性 -->
    <div class="custom_dialog" v-if="isAttrPopup">
      <div class="custom_dialog_container">
        <div class="custom_dialog_close" @click="isAttrPopup = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
        <div class="custom_dialog_head flex-rowl">
          <div class="custom_dialog_tit active">Add Products</div>
        </div>
        <div class="custom_dialog_body attr_dialog_body flex-between">
          <div class="custom_dialog_body_left">
            <el-image
              style="width: 100%; height: 100%"
              :src="commodityDetail.img"
              fit="cover"
            ></el-image>
          </div>
          <div class="custom_dialog_body_right">
            <!-- 属性、数量 -->
            <div class="custom_dialog_body_right_main" v-if="!isSetLogistics">
              <div class="attr_list">
                <div
                  class="attr_item"
                  v-for="(item, index) in attrList"
                  :key="index"
                >
                  <div class="tit">{{ item.mul_attrname }}</div>
                  <div class="attrvalue_list flex-rowl">
                    <div
                      class="attrvalue_item flex-rowl"
                      v-for="(itemChild, indexChild) in item.items"
                      :key="indexChild"
                      :class="{
                        no_icon: !itemChild.pic, // 新增判断是否为选中的属性值
                        selected: isAttrValueSelected(
                          item.attrid,
                          itemChild.id
                        ),
                      }"
                      @click="handleAttrItemClick(item.attrid, itemChild.id)"
                    >
                      <!-- {{ 'select_' + item.attrname +'_'+ item.attrid }} == {{ defaultOrderAttr.attrObj['select_' + item.attrname +'_'+ item.attrid].item.id }}==== {{ itemChild.id }}=== -->
                      <div class="icon" v-if="itemChild.pic"></div>
                      <p>{{ itemChild.mul_attrvalue }}</p>
                      <!-- 选中图标 -->
                      <span
                        class="select_radio"
                        v-if="isAttrValueSelected(item.attrid, itemChild.id)"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="num_block">
                <div class="tit">Quantity</div>
                <div class="step_wrap flex-rowl">
                  <input
                    type="text"
                    :value="defaultOrderAttr.num"
                    @blur="handleInputBlur"
                  />
                  <span
                    class="icon-add-step"
                    @click="handleQuantityChange('increase')"
                  ></span>
                  <span
                    class="icon-reduce-step"
                    @click="handleQuantityChange('decrease')"
                  ></span>
                </div>
              </div>
              <div class="add_edit_block">
                <div class="tit">Delivery</div>
                <div
                  class="edit_block flex-between"
                  v-if="!isSetLogistics && defaultOrderAttr.receivingObj.id"
                >
                  <div class="edit_block_main">
                    <h1>{{ defaultOrderAttr.receivingObj.truename }}</h1>
                    <p>{{ defaultOrderAttr.receivingObj.mobile }}</p>
                    <p>
                      <span v-if="defaultOrderAttr.receivingObj.province"
                        >{{ defaultOrderAttr.receivingObj.province }}、</span
                      >
                      <span v-if="defaultOrderAttr.receivingObj.city"
                        >{{ defaultOrderAttr.receivingObj.city }}、</span
                      >
                      <span v-if="defaultOrderAttr.receivingObj.area">{{
                        defaultOrderAttr.receivingObj.area
                      }}</span>
                      <span v-if="defaultOrderAttr.receivingObj.addr">{{
                        defaultOrderAttr.receivingObj.addr
                      }}</span>
                    </p>
                  </div>
                  <div class="edit_block_operation flex-rowr">
                    <i
                      class="iconfont icon-xiugai"
                      @click="isSetLogistics = true"
                    ></i>
                    <i
                      class="iconfont icon-close"
                      @click="handleClearLogistics"
                    ></i>
                  </div>
                </div>
                <div
                  class="add_btn flex-rowl"
                  v-else
                  @click="hadnelShowLogidtics"
                >
                  <i class="iconfont icon-jiahao1"></i>Set separate delivery
                  information for these products. Delivery
                </div>
              </div>
            </div>
            <!-- 单独的物流信息 -->
            <div class="custom_dialog_body_right_logistics" v-else>
              <div class="logistics_head">
                <div class="logistics_tit flex-between">
                  <p>
                    Set separate delivery information for these products.
                    Delivery to...
                  </p>
                  <span
                    class="iconfont icon-close"
                    @click="isSetLogistics = false"
                  ></span>
                </div>
                <div class="logistics_subTit">Send to Designated Recipient</div>
              </div>
              <div class="logistics_body">
                <div
                  class="address_list"
                  v-if="!customLoading && receivingList.length > 0"
                >
                  <div
                    v-for="(item, index) in receivingList"
                    :key="index"
                    @click="handleSetLogistics(item)"
                    class="address_item flex-rowl"
                    :class="{
                      active: item.id == defaultOrderAttr.receivingObj.id,
                    }"
                  >
                    <div class="radio flex-rowl">
                      <span
                        class="iconfont"
                        :class="
                          item.id == defaultOrderAttr.receivingObj.id
                            ? 'icon-danxuanyixuan1'
                            : 'icon-quanxuan'
                        "
                      ></span>
                    </div>
                    <div class="address_content flex-rowl">
                      <div class="address_content_item">
                        <h1>{{ item.truename }}</h1>
                        <p>{{ item.mobile }}</p>
                        <p>
                          <span>{{ item.province }}、</span>
                          <span>{{ item.city }}、</span>
                          <span>{{ item.area }}</span>
                        </p>
                      </div>
                      <div class="address_content_item">
                        <p>{{ item.addr }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <el-empty
                  :description="$t('NoData')"
                  v-if="!customLoading && receivingList.length == 0"
                ></el-empty>
              </div>
            </div>
          </div>
        </div>
        <div class="custom_dialog_footer flex-rowr">
          <div
            class="custom_dialog_footer_btn flex-rowc"
            @click="handleAddOrder"
            v-if="!isSetLogistics"
          >
            Add to Order <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { encryptstringview, getCommidityDetail } from "../../../api/api";
import {
  getLogisticsAddressList,
  getSpecialUserResourceList,
} from "../../../api/managCenter";
import {
  getOrderChannelList,
  addLsOrder,
  getLanguageShopDetail,
} from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cRetailAddOrder",
  data() {
    return {
      id: "", // 商品id
      // 商品详情
      commodityDetail: {},
      // 详情内容
      detailContent: "",
      loading: false,

      showAllLabels: false, // 是否显示所有标签

      // 整体订单物流信息
      isLogistics: false,
      activeName: "second",
      customLoading: false,
      // 收获信息管理
      receivingList: [],
      // 仓库信息
      warehouseList: {},
      // 当前选中物流信息类型
      currentLogisticsType: "", // 可选值: 'receiving_info'：收货信息, 'warehouse_info'：仓库信息

      // 商品属性 start
      // 商品属性弹窗
      isAttrPopup: false,
      attrList: [],
      // 默认属性
      defaultOrderAttr: {
        attrObj: {}, // 选中的属性
        num: 1,
        price: "", // 单价
        price_total: "", // 总价
        mul_price: "", // 单价-多语言
        mul_price_total: "", // 总价-多语言
        attrnumtype: "", // 属性价格变动类型： 不变、增加、减少
        attrnum: "", // 属性价格变动值
        codetype: "", // 优惠价类型 1-百分比、2-固定金额
        discount: "", // 优惠券值
        msgtype: 2, //
        receivingObj: {}, // 收货信息
      },
      // 是否设置了单独的物流信息
      isSetLogistics: false,

      // 商品属性 end

      // 商品banner
      bannerList: [],
      // 当前选中banner的索引
      currentBannerIndex: 0,

      // 商品总数量
      totalNum: 0,
      currentPrice: 0, // 默认商品单价
      mul_currentPrice: 0, // 默认商品单价 - 多语言
      totalPrice: 0, // 订单总价
      mul_totalPrice: 0, // 订单总价 - 多语言
      mul_totalPrice_str: 0, // 格式化后的商品总价格 - 多语言
      // 已选中的总订单物流信息
      selectedOrderLogistics: {},
      // 已选中的商品属性列表
      selectedOrderAttrList: [],

      formData: {
        Method: "addorder_ordertype60",
        qyid: "",
        openid: "",
        ticket: "",
        goods: "",
        price_original: 0, // 商品原价
        price: 0, // 商品总价
        sendtime: "",
        addr: "",
        msg: "",
        ordertype: 2, // 2 = 普通商品订单 // 41=分销订单 42=团购订单 43=销售业务订单 44=批发订单 45=门店线下零售订单 46=门店线上应用零售订单 47=门店店仓提货  52=混批订单  60=第三方零售渠道订单
        boxlogid: "",
        runfee: 0,
        runfeetype: 6,
        score: 0,
        days: "",
        truename: "",
        cellphone: "",
        logisticsdf: 2, // 物流是否到付 =1=到付 2=其它
        diffrentprice: "", // 订单差额
        paymsg: "", // 支付信息
        paymsg_truename: "", // 支付信息-账户名
        paymsg_bank: "", // 支付信息-开户行
        paymsg_account: "", // 支付信息-账号
        saler: "", // 销售人员关联
        saler_note: "", // 销售人员备注
        channelid: "", //订单来源
        inarea: "", // 订单所属区域
        pics: "", //  订单信息截图凭证
        currency: "", // 商品币种
        currency_trans: "", // 订单交易币种 接口521获取id
        qy_truename: "", // 企业名称
        qy_linktype: "", // 企业电话
      },
    };
  },
  filters: {
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return;
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "COUNTRY", "USERINFO"]),
  },
  created() {
    let { USERINFO, routerList, OPENID } = this.$store.state;
    this.formData.openid = OPENID;
    this.formData.qy_truename = USERINFO.truename;
    this.formData.qy_linktype = USERINFO.linkphone ? USERINFO.linkphone : "";
    this.formData.inarea = USERINFO.countryExrateObj.countryname;
    this.formData.currency_trans = USERINFO.countryExrateObj.id;

    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, type, qyid } = JSON.parse(res.jsondata);
        console.log(id, type);
        this.id = id;
        this.formData.qyid = qyid;
        this.getCommidityDetail();
        this.getOrderChannelList();
      } else {
        this.$router.back();
      }
    },

    handleMultilingualName(type, dataList, key1, key2) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v[`mul_${key1}`] = v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.price;
            v.mul_groupprice = v.groupprice;
            v.mul_pfprice = v.pfprice;
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
            v.mulstr_groupprice = formatPrice(v.groupprice);
            v.mulstr_pfprice = formatPrice(v.pfprice);
          }
          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 8) {
          // 英文
          v[`mul_${key1}`] = v[key1 + "_e"] ? v[key1 + "_e"] : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_e"] ? v[key2 + "_e"] : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.ame_price
              ? v.ams_shop_commodity_exrate.ame_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.ame_tuan
              ? v.ams_shop_commodity_exrate.ame_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.ame_tuan_base
              ? v.ams_shop_commodity_exrate.ame_tuan_base
              : "";

            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
            v.mulstr_groupprice = formatPrice(v.mul_groupprice);
            v.mulstr_pfprice = formatPrice(v.mul_pfprice);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 2) {
          // 俄语
          v[`mul_${key1}`] = v[key1 + "_m"]
            ? v[key1 + "_m"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_m"]
              ? v[key2 + "_m"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_m
                  ? label.labelcont_m
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.lu_price
              ? v.ams_shop_commodity_exrate.lu_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.lu_tuan
              ? v.ams_shop_commodity_exrate.lu_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.lu_tuan_base
              ? v.ams_shop_commodity_exrate.lu_tuan_base
              : "";

            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
            v.mulstr_groupprice = formatPrice(v.mul_groupprice);
            v.mulstr_pfprice = formatPrice(v.mul_pfprice);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_m
                  ? child2.labelname_m
                  : child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_m
                      ? child3.labelname_m
                      : child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 4) {
          // 越语
          v[`mul_${key1}`] = v[key1 + "_y"]
            ? v[key1 + "_y"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_y"]
              ? v[key2 + "_y"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_y
                  ? label.labelcont_y
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.yue_price
              ? v.ams_shop_commodity_exrate.yue_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.yue_tuan
              ? v.ams_shop_commodity_exrate.yue_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.yue_tuan_base
              ? v.ams_shop_commodity_exrate.yue_tuan_base
              : "";
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
            v.mulstr_groupprice = formatPrice(v.mul_groupprice);
            v.mulstr_pfprice = formatPrice(v.mul_pfprice);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_y
                  ? child2.labelname_y
                  : child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_y
                      ? child3.labelname_y
                      : child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        }
      });
      return dataList;

      // 定义处理价格格式的函数
      function formatPrice(price) {
        const priceStr = String(price);
        const parts = priceStr.split(".");
        if (parts.length > 1) {
          return `${parts[0]}.<span>${parts[1]}</span>`;
        }
        return priceStr;
      }
    },

    // 判断是否选中属性值
    /**
     *
     * @param {*} attrid 属性id
     * @param {*} itemId 属性值id
     * @returns
     */
    isAttrValueSelected(attrid, itemId) {
      const key = `select_${
        this.attrList.find((attr) => attr.attrid == attrid).attrname
      }_${attrid}`;
      return (
        this.defaultOrderAttr.attrObj[key] &&
        this.defaultOrderAttr.attrObj[key].item.id == itemId
      );
    },

    // 商品详情
    getCommidityDetail() {
      this.loading = true;
      getCommidityDetail({ id: this.id }).then((res) => {
        // 对banner进行处理，对应的字段分别为banner、banner2、banner3、banner4、banner5、banner6、banner7、banner8、banner9
        let bannerList = [];
        if (res.banner) {
          bannerList.push(res.banner);
        }
        for (let i = 2; i <= 9; i++) {
          const bannerKey = `banner${i}`;
          if (res[bannerKey]) {
            bannerList.push(res[bannerKey]);
          }
        }
        this.bannerList = bannerList;

        let MultilingualArr = this.handleMultilingualName(
          "shop",
          [res],
          "commodityname",
          "shortname"
        );
        this.commodityDetail = MultilingualArr[0];
        this.currentPrice = this.commodityDetail.price; // 默认商品单价
        this.mul_currentPrice = this.commodityDetail.mul_price; // 默认商品单价 - 多语言

        // 不同国家选择多语言
        this.handleMultilingualName("atr", res.attr, "attrname");
        res.attr.forEach((v) => {
          // 不同国家选择多语言
          this.handleMultilingualName("atr", v.items, "attrvalue");
        });
        this.detailContent = res.details;

        // 当前语言为中文则直接赋值详情内容，否则获取其它语言详情
        if (this.COUNTRY.countryid == 1) {
          this.detailContent = res.details;
          this.detailContent.sort((a, b) => a.sortno - b.sortno);
        } else {
          this.getLanguageShopDetail();
        }
        this.attrList = res.attr;
        this.loading = false;
      });
    },

    // 其它语言详情
    getLanguageShopDetail() {
      let { countryid } = this.COUNTRY;
      // countryid = 8 ，LanType=e；countryid = 4 ，LanType=y；countryid = 2 ，LanType=m；countryid = 5 ，LanType=t ；countryid = 3 ，LanType=r；
      let LanType = "";
      if (countryid == 8) {
        LanType = "e";
      } else if (countryid == 4) {
        LanType = "y";
      } else if (countryid == 2) {
        LanType = "m";
      } else if (countryid == 5) {
        this.LanType = "t";
      } else if (countryid == 3) {
        LanType = "r";
      }
      let params = {
        lan: LanType,
        id: this.id,
      };
      getLanguageShopDetail(params).then((res) => {
        this.detailContent = res.details;
        this.detailContent.sort((a, b) => a.sortno - b.sortno);
      });
    },

    // 获取订单来源
    getOrderChannelList() {
      getOrderChannelList().then((res) => {
        let newRes = res.list.filter((v) => v.isusestr == "是");
        //
        let filter = newRes.filter(
          (v) =>
            v.channel == "TikTok" ||
            v.channel == "Temu" ||
            v.channel == "Wildberries" ||
            v.channel == "Partner's Offline Stores/Shop" ||
            v.channel == "OZON" ||
            v.channel == "Partner Independent Website" ||
            v.channel == "Partner Independent APP" ||
            v.channel == "Telegram" ||
            v.channel == "VK" ||
            v.channel == "Yandex Market" ||
            v.channel == "Others" ||
            v.channel == "Instagram"
        );
        this.channelList = filter;

        // 如果为普通用户，则默认选择官方海外选品中心
        if (this.USERINFO.useridentity == "普通用户") {
          newRes.forEach((v) => {
            if (v.channel == "官方海外选品中心") {
              this.formData.channelid = v.id;
            }
          });
        }
      });
    },

    // 获取个人收货信息
    getLogisticsAddressList() {
      this.customLoading = true;
      let params = {
        pageindex: 1,
        pagesize: 25,
        keyword: "",
        openid: this.OPENID,
        countryids: this.USERINFO.countryExrateObj.countryid,
      };
      getLogisticsAddressList(params).then((res) => {
        if (res.result) {
          this.receivingList = res.list;
        }
        this.customLoading = false;
      });
    },

    // 获取仓库信息
    getSpecialUserResourceList() {
      this.customLoading = true;
      let params = {
        pageindex: 1,
        pagesize: 25,
        keyword: "",
        isuse: "", // 是否启用 =1=启用 0=停用
        openid: this.OPENID,
        whtype: "", // 仓库服务类型 =私有仓 公共服务仓
        managetype: "", // 管理属性 =工厂 第三方服务机构 标准仓库
        countryids: this.USERINFO.countryExrateObj.countryid, // 所在国家
        runstate: "", // 业务状态管理 =1=开启入库&代发业务 2=关闭入库&代发业务
        replacetype: "", // 代发业务模式管理 =1=一件代发（to 零售） 2=大货代发（to 集运） 3=退换货处理（to 零售）
        fee_cny: "", // 出入库服务收费币种
      };
      getSpecialUserResourceList(params).then((res) => {
        if (res.result) {
          let MultilingualArr = this.handleMultilingualName(
            "warehouse",
            res.list,
            "whname"
          );
          this.warehouseList = MultilingualArr;
        }
        this.customLoading = false;
      });
    },

    // 下载图片
    downloadImage(url) {
      window.open(url, "_blank");
    },

    // 点击更多热门搜索
    handleLabelMore() {
      this.showAllLabels = !this.showAllLabels;
    },
    // 鼠标移入显示全部热门搜索
    handleMouseLeave() {
      this.showAllLabels = false;
    },

    // 触发按钮显示弹窗
    handleShowPopup(type, orderItem) {
      if (type == 1) {
        this.getLogisticsAddressList();
        // 显示物流信息弹窗
        this.isLogistics = true;
      } else if (type == 2) {
        // 默认选择所有属性下的第一个值
        let newAttrObj = {};
        // 如果orderItem有值，则表示是编辑商品属性
        if (orderItem) {
          let { attrObj } = orderItem;
          newAttrObj = attrObj;
        } else {
          let { attrList } = this;
          attrList.forEach((attr) => {
            const key = `select_${attr.attrname}_${attr.attrid}`;
            newAttrObj[key] = {
              attrid: attr.attrid,
              attrname: attr.mul_attrname,
              item: attr.items[0],
            };
          });
        }

        // 初始化defaultOrderAttr中其他的数据
        this.defaultOrderAttr = {
          attrObj: newAttrObj, // 选中的属性
          num: orderItem ? orderItem.num : 1, // 数量
          price: "", // 单价
          price_total: "", // 总价
          mul_price: "", // 单价-多语言
          mul_price_total: "", // 总价-多语言
          attrnumtype: "", // 属性价格变动类型： 不变、增加、减少
          attrnum: "", // 属性价格变动值
          codetype: "", // 优惠价类型 1-百分比、2-固定金额
          discount: "", // 优惠券值
          msgtype: 2, //
          receivingObj: orderItem ? orderItem.receivingObj : {}, // 收货信息
          // 新增数据的guid是随机生成的，编辑数据的guid是原来的guid
          guid: orderItem ? orderItem.guid : this.generateGUID(),
        };

        // 显示商品属性弹窗
        this.isAttrPopup = true;
      }
    },
    // 切换物流信息tab
    handleTabClick(tab) {
      this.activeName = tab;
      if (tab == "second") {
        this.getLogisticsAddressList();
      } else if (tab == "first") {
        this.getSpecialUserResourceList();
      }
    },
    // 触发选择物流信息
    handleLogisticsItem(type, item) {
      this.selectedOrderLogistics = item;
      this.currentLogisticsType = type;
      this.isLogistics = false;
    },
    // 触发编辑物流信息
    handleEditLogistics() {
      // 判断currentLogisticsType类型，显示对应的activeName
      if (this.currentLogisticsType == "receiving_info") {
        this.activeName = "second";
        this.getLogisticsAddressList();
      } else if (this.currentLogisticsType == "warehouse_info") {
        this.activeName = "first";
        this.getSpecialUserResourceList();
      }
      this.isLogistics = true;
    },
    // 触发删除物流信息
    handleDelLogistics() {
      this.selectedOrderLogistics = {};
      this.currentLogisticsType = "";
    },

    // 触发数量输入框失去焦点时的处理 输入框只能输入数字，且大于等于1 且只能输入整数
    handleInputBlur(event) {
      const inputValue = parseInt(event.target.value, 10);
      if (!isNaN(inputValue) && inputValue >= 1) {
        this.defaultOrderAttr.num = inputValue;
        this.finalPriceCalculate(); // 重新计算总价
      } else {
        // 如果输入的值不是有效的数字或小于 1，则恢复为原来的值
        event.target.value = this.defaultOrderAttr.num;
      }
    },

    // 触发数量增加或减少
    handleQuantityChange(type) {
      if (type === "increase") {
        this.defaultOrderAttr.num++;
      } else if (type === "decrease" && this.defaultOrderAttr.num > 1) {
        this.defaultOrderAttr.num--;
      }
    },

    // 触发选择属性
    handleAttrItemClick(attrid, itemId) {
      const attr = this.attrList.find((attr) => attr.attrid == attrid);
      const key = `select_${attr.attrname}_${attrid}`;
      const newObj = {
        attrid: attrid,
        attrname: attr.mul_attrname,
        item: attr.items.find((item) => item.id == itemId),
      };
      // 使用 this.$set 确保 Vue 能检测到对象属性的变化
      this.$set(this.defaultOrderAttr.attrObj, key, newObj);
      this.$forceUpdate(); // 强制更新组件
    },

    // 删除商品属性
    handleDelOrderItem(item) {
      let index = this.selectedOrderAttrList.findIndex(
        (v) => v.guid == item.guid
      );
      if (index != -1) {
        this.selectedOrderAttrList.splice(index, 1);
      }
      this.finalPriceCalculate(); // 计算最终价格
    },

    // 设置单个商品物流信息
    hadnelShowLogidtics() {
      this.getLogisticsAddressList();
      this.isSetLogistics = true;
    },
    // 触发单个商品的物流
    handleSetLogistics(item) {
      this.defaultOrderAttr.receivingObj = item;
      this.isSetLogistics = false;
    },
    // 清除单个商品的物流
    handleClearLogistics() {
      this.defaultOrderAttr.receivingObj = {};
      this.isSetLogistics = false;
    },

    handleAddOrder() {
      let { defaultOrderAttr, commodityDetail } = this;
      // 创建一个新的对象，其中对象中包含attr、commodityid、commoditylabel、commodityname、num、price、price_total、attrnumtype、attrnum、codetype、discount、msgtype、msgman、msglink、msgaddr
      // console.log(defaultOrderAttr.attrObj);/

      // 自定义newAttrValueArr数组，用于存储attrObj中的attrvalue
      let newAttrValueArr = [];
      for (const key in defaultOrderAttr.attrObj) {
        const attrItem = defaultOrderAttr.attrObj[key];
        newAttrValueArr.push(attrItem.item.mul_attrvalue);
      }
      let newOrder = {
        attrObj: defaultOrderAttr.attrObj,
        newAttrValueArr,
        commodityid: commodityDetail.id,
        commoditylabel: "",
        commodityname: commodityDetail.commodityname,
        // commodityname: commodityDetail.mul_commodityname,
        num: defaultOrderAttr.num,
        price: 0,
        price_total: 0,
        mul_price: 0, // 单价-多语言
        mul_price_total: 0, // 总价-多语言
        attrnumtype: "",
        attrnum: "",
        codetype: defaultOrderAttr.codetype,
        discount: defaultOrderAttr.discount,
        msgtype: defaultOrderAttr.msgtype,
        guid: defaultOrderAttr.guid,
        receivingObj: defaultOrderAttr.receivingObj,
      };

      // 如果defaultOrderAttr.guid的值和selectedOrderAttrList中某个对象的guid的值相等，则表示是编辑商品属性；否则表示是新增商品属性
      let index = this.selectedOrderAttrList.findIndex(
        (v) => v.guid == defaultOrderAttr.guid
      );
      if (index != -1) {
        this.selectedOrderAttrList.splice(index, 1, newOrder);
      } else {
        this.selectedOrderAttrList.push(newOrder);
      }
      this.isAttrPopup = false;
      this.finalPriceCalculate(); // 计算最终价格
    },

    // 计算最终的属性价格
    calculateFinalAttributePrice() {
      let totalAttributePrice = 0; // 属性总价
      let mul_totalAttributePrice = 0; // 属性总价-多语言
      const { defaultOrderAttr } = this;
      let { rate, Currencystr } = this.USERINFO.countryExrateObj;
      for (const key in defaultOrderAttr.attrObj) {
        const attrItem = defaultOrderAttr.attrObj[key];
        const { numtype, num } = attrItem.item;

        let priceChange = 0;
        if (numtype === "增加") {
          priceChange = num;
        } else if (numtype === "减少") {
          priceChange = -num;
        }
        totalAttributePrice += priceChange;
      }

      if (
        Currencystr == "越南盾" ||
        Currencystr == "泰铢" ||
        Currencystr == "卢布" ||
        Currencystr == "日元"
      ) {
        mul_totalAttributePrice = Math.round(
          calculator(totalAttributePrice).divide(rate).toNumber()
        );
      } else {
        let priceString = calculator(totalAttributePrice)
          .divide(rate)
          .toNumber()
          .toFixed(2); // toFixed()方法返回的是一个字符串
        mul_totalAttributePrice = parseFloat(priceString); // 使用parseFloat()或Number()将其转换回数字
      }

      return { totalAttributePrice, mul_totalAttributePrice };
    },

    // 最终价格计算
    finalPriceCalculate() {
      let { selectedOrderAttrList, commodityDetail } = this;
      // 计算订单总数量
      let totalNum = selectedOrderAttrList.reduce((acc, v) => acc + v.num, 0);

      // 订单的最终价格、订单类型
      let { newPrice, mul_newPrice, mul_newPrice_str, orderType } =
        this.calculatePrice(
          totalNum,
          commodityDetail.startnum2,
          commodityDetail.startnum3,
          commodityDetail.price,
          commodityDetail.groupprice,
          commodityDetail.pfprice,
          commodityDetail.mul_price,
          commodityDetail.mul_groupprice,
          commodityDetail.mul_pfprice,
          commodityDetail.mulstr_price,
          commodityDetail.mulstr_groupprice,
          commodityDetail.mulstr_pfprice
        );

      // 计算最终属性价格totalAttributePrice-属性总价、mul_totalAttributePrice-属性总价-多语言
      let { totalAttributePrice, mul_totalAttributePrice } =
        this.calculateFinalAttributePrice();

      // 重新计算selectedOrderAttrList中price、price_total的值
      selectedOrderAttrList.forEach((v) => {
        v.price = calculator(newPrice).subtract(totalAttributePrice).toNumber();
        // mul_price = newPrice + mul_totalAttributePrice
        v.mul_price = calculator(mul_newPrice)
          .subtract(mul_totalAttributePrice)
          .toNumber();
        // mul_price_total = price * v.num

        v.price_total = calculator(v.price).multiply(v.num).toNumber();
        v.mul_price_total = calculator(v.mul_price).multiply(v.num).toNumber();

        // totalAttributePrice的大小判断attrnumtype、attrnum的值，如果totalAttributePrice大于0，则attrnumtype为增加，attrnum为totalAttributePrice，否则attrnumtype为减少，attrnum为totalAttributePrice的绝对值，如果totalAttributePrice等于0，则attrnumtype为不变，attrnum为0
        if (totalAttributePrice > 0) {
          v.attrnumtype = "增加";
          v.attrnum = totalAttributePrice;
        } else if (totalAttributePrice < 0) {
          v.attrnumtype = "减少";
          v.attrnum = Math.abs(totalAttributePrice);
        } else {
          v.attrnumtype = "不变";
          v.attrnum = 0;
        }
      });
      // 计算订单总价格-多语言
      this.mul_totalPrice = selectedOrderAttrList.reduce(
        (acc, v) => acc + v.mul_price_total,
        0
      );

      // 计算订单总价格-多语言
      this.totalPrice = selectedOrderAttrList.reduce(
        (acc, v) => acc + v.price_total,
        0
      );

      this.totalNum = totalNum;
      this.currentPrice = newPrice; // 单价
      this.mul_currentPrice = mul_newPrice_str; // 单价-多语言
      this.selectedOrderAttrList = selectedOrderAttrList;
      this.mul_totalPrice_str = formatPrice(this.mul_totalPrice);
      this.formData.ordertype = orderType;

      // 定义处理价格格式的函数
      function formatPrice(price) {
        const priceStr = String(price);
        const parts = priceStr.split(".");
        if (parts.length > 1) {
          return `${parts[0]}.<span>${parts[1]}</span>`;
        }
        return priceStr;
      }

      console.log(orderType);
    },

    calculatePrice(
      num,
      startnum2,
      startnum3,
      price,
      groupprice,
      pfprice,
      mul_price,
      mul_groupprice,
      mul_pfprice,
      mulstr_price,
      mulstr_groupprice,
      mulstr_pfprice
    ) {
      /**
       * 价格的计算规则
       * 1、如果商品数量小于startnum2并且不为null时，则最终价格为零售价price，orderType=2（普通零售订单）
       * 2、如果商品数量大于等于startnum2，小于startnum3，并且startnum3不为null时，则最终价格为 商品基础批发价（团批）价（/件）=groupprice，orderType=44（批发订单）
       * 3、如果商品数量大于等于startnum2，小于startnum3，并且startnum3为null时，则最终价格为 商品基础批发价（团批）价（/件）=groupprice，orderType=44（批发订单）
       * 4、如果商品数量大于等于startnum3，则最终价格为 商品批发（团批）分销底价（/件）=pfprice，orderType=44（批发订单）
       */
      let newPrice = 0;
      let mul_newPrice = 0; // 单价-多语言
      let mul_newPrice_str = 0; // 单价-多语言-字符串
      let orderType = 2;
      // 用户类型 1-普通用户，则保持之前的
      if (this.USERINFO.useridentity != "普通用户") {
        orderType = 60;
        return { price, mul_price, orderType, mul_newPrice_str };
      }

      if (startnum2 !== null && num < startnum2) {
        newPrice = price;
        mul_newPrice = mul_price;
        mul_newPrice_str = mulstr_price;
        orderType = 2;
      } else if (
        startnum2 !== null &&
        startnum3 !== null &&
        num >= startnum2 &&
        num < startnum3
      ) {
        newPrice = groupprice;
        mul_newPrice = mul_groupprice;
        mul_newPrice_str = mulstr_groupprice;
        orderType = 44;
      } else if (startnum2 !== null && startnum3 === null && num >= startnum2) {
        newPrice = groupprice;
        mul_newPrice = mul_groupprice;
        mul_newPrice_str = mulstr_groupprice;
        orderType = 44;
      } else if (startnum3 !== null && num >= startnum3) {
        newPrice = pfprice;
        mul_newPrice = mul_pfprice;
        mul_newPrice_str = mulstr_pfprice;
        orderType = 44;
      }
      return { newPrice, mul_newPrice, mul_newPrice_str, orderType };
    },

    // guid生成器
    generateGUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    // 提交订单
    submitOrder() {
      // 如果订单数量为0，提示用户添加商品
      let {
        totalNum,
        selectedOrderAttrList,
        selectedOrderLogistics,
        currentLogisticsType,
        totalPrice,
        mul_totalPrice,
        commodityDetail,
      } = this;
      if (
        totalNum == 0 ||
        selectedOrderAttrList.length == 0 ||
        !selectedOrderLogistics.id
      )
        return;

      // 新增商品属性列表
      let newGoods = [];
      selectedOrderAttrList.forEach((v) => {
        let newAttr = [];
        for (const key in v.attrObj) {
          const attrItem = v.attrObj[key];
          let attrStr = attrItem.attrname + ":" + attrItem.item.mul_attrvalue;
          newAttr.push(attrStr);
        }
        let obj = {
          attr: newAttr,
          commodityid: commodityDetail.id,
          commoditylabel: "",
          commodityname: commodityDetail.commodityname,
          num: v.num,
          price: v.price,
          price_total: v.price_total,
          attrnumtype: v.attrnumtype,
          attrnum: v.attrnum,
          codetype: v.codetype,
          discount: v.discount,
          msgtype: v.msgtype,
          msgman: v.receivingObj.id ? v.receivingObj.truename : "",
          msglink: v.receivingObj.id ? v.receivingObj.mobile : "",
          msgaddr: v.receivingObj.id
            ? v.receivingObj.province +
              v.receivingObj.city +
              v.receivingObj.area +
              v.receivingObj.addr
            : "",
          guid: this.generateGUID(),
        };
        newGoods.push(obj);
      });

      // 订单总价：price = 当前国家商品的最终价格 / 当前国家的汇率
      // 价格小数点的处理 越南盾、泰铢、卢布、日元则需要保持保持整数，其他国家保持小数点后两位
      let { rate, Currencystr } = this.USERINFO.countryExrateObj;
      if (
        Currencystr == "越南盾" ||
        Currencystr == "泰铢" ||
        Currencystr == "卢布" ||
        Currencystr == "日元"
      ) {
        this.formData.price = Math.round(
          calculator(mul_totalPrice).divide(rate).toNumber()
        );
      } else {
        let priceString = calculator(mul_totalPrice)
          .divide(rate)
          .toNumber()
          .toFixed(2); // toFixed()方法返回的是一个字符串
        this.formData.price = parseFloat(priceString); // 使用parseFloat()或Number()将其转换回数字
      }

      this.formData.goods = JSON.stringify(newGoods);
      this.formData.price_original = totalPrice; // 订单总价：price_original = 中文国家商品的最终价格
      this.formData.truename =
        currentLogisticsType == "receiving_info"
          ? selectedOrderLogistics.truename
          : selectedOrderLogistics.manager;
      this.formData.cellphone =
        currentLogisticsType == "receiving_info"
          ? selectedOrderLogistics.mobile
          : selectedOrderLogistics.linktype;
      this.formData.addr = selectedOrderLogistics.countryidsstr
        ? selectedOrderLogistics.countryidsstr
        : "" +
          selectedOrderLogistics.province +
          selectedOrderLogistics.city +
          selectedOrderLogistics.area +
          selectedOrderLogistics.addr;

      this.loading = true;
      addLsOrder(this.formData).then((res) => {
        if (res.result) {
          let message = this.$message.success(res.msg);
          setTimeout(() => {
            this.loading = false;
            message.close();
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(this.$t("Server Error"));
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.retail_add_order_container {
  background: #e7e8f0;
  padding-top: 120px;
  box-sizing: border-box;
  .custom_breadcrumb_label_wrap {
    height: 60px;
    background: #fff;
    padding: 0 280px;
    box-sizing: border-box;
    margin-bottom: 20px;
    position: fixed;
    left: 0;
    right: 0;
    top: 60px;
    z-index: 11;
    .custom_breadcrumb {
      p {
        font-size: 16px;
        color: #2c2c2c;
        font-weight: bold;
        cursor: pointer;
      }
      span {
        margin: 0 10px;
        transform: rotate(180deg);
      }
    }
    .label_wrap {
      position: relative;
      .label_icon {
        width: 16px;
        height: 17px;
        margin-right: 10px;
        background: url("../../../assets/images/label_icon.png") no-repeat
          center;
        background-size: cover;
      }
      .label_list {
        font-size: 16px;
        color: #026dd1;
        .label_item {
          margin-right: 15px;
        }
      }
      .label_btn {
        width: 110px;
        height: 30px;
        background: #000000;
        border-radius: 15px;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
        padding-left: 20px;
        box-sizing: border-box;
        .iconfont {
          background: url("../../../assets/images/label_btn_icon.png") no-repeat
            center;
          background-size: cover;
          width: 18px;
          height: 18px;
          margin-left: 4px;
        }
      }
      .more_label_wrap_expanded {
        position: absolute;
        right: 0;
        top: 40px;
        width: 780px;
        min-height: 120px;
        background: #fff;
        box-shadow: 0px 6px 10px 0px rgba(13, 0, 0, 0.1);
        z-index: 10001;
        padding: 16px 10px 20px 35px;
        box-sizing: border-box;
        /* 确保内容在动画过程中不会溢出 */
        overflow: hidden;
        /* 新增过渡属性 */
        transition: all 0.3s ease;
        transform-origin: top;
        &::before {
          content: "";
          position: absolute;
          width: 100px;
          height: 10px;
          background: #000000;
          right: 0;
          top: 0;
        }
        .more_label_list {
          font-size: 16px;
          color: #026dd1;
          flex-wrap: wrap;
          .more_label_item {
            margin-right: 30px;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
      }
      /* 过渡动画 */
      .slide-enter-active,
      .slide-leave-active {
        transition: all 0.3s ease;
      }

      .slide-enter,
      .slide-leave-to {
        transform: scaleY(0);
        opacity: 0;
      }
    }
  }

  .main_container {
    height: calc(100vh - 310px);
    overflow-y: scroll;
    padding-bottom: 75px;
    box-sizing: border-box;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
    .content_container {
      margin: 20px 280px 80px;
      align-items: flex-start;
      .shop_info_container {
        width: 560px;
        flex-shrink: 0;
        margin-right: 45px;
        .shop_info_banner {
          width: 100%;
          height: 690px;
          background: #fff;
          position: relative;
          .shop_info_banner_box {
            width: 100%;
            height: 100%;
          }
          .shop_info_banner_list {
            position: absolute;
            height: 100%;
            padding: 20px;
            box-sizing: border-box;
            z-index: 1;
            overflow-y: scroll;
            // 隐藏滚动条
            &::-webkit-scrollbar {
              display: none;
            }
            .shop_info_banner_item {
              width: 60px;
              height: 70px;
              border-radius: 10px;
              overflow: hidden;
              margin-bottom: 3px;
              cursor: pointer;
              background: #ea4e4e;
              &:last-child {
                margin-bottom: 0;
              }
              &.active {
                border: 2px solid #fff;
              }
            }
          }
          .shop_info_banner_operation {
            position: absolute;
            right: 20px;
            bottom: 20px;
            z-index: 11;
            span {
              cursor: pointer;
              width: 30px;
              height: 30px;
            }
            .icon-xiazai {
              background: url("../../../assets/images/icon-xiazai.png")
                no-repeat center;
              background-size: cover;
            }
            .kuaijin-box {
              width: 30px;
              height: 30px;
              margin-left: 7px;
              cursor: pointer;
            }
          }
        }
        .shop_info_btn {
          width: 100%;
          height: 50px;
          background: #333333;
          margin-top: 10px;
          font-size: 18px;
          color: #fff;
          cursor: pointer;
          &::after {
            display: inline-block;
            content: "";
            background: url("../../../assets/images/icon-double-arrow-down.png")
              no-repeat center;
            background-size: cover;
            width: 18px;
            height: 15px;
            margin-left: 10px;
          }
        }
      }
      .order_info_container {
        flex: 1;
        h1 {
          font-size: 28px;
          color: #333333;
          margin-bottom: 10px;
        }
        .label_list {
          margin-bottom: 20px;
          .label_item {
            font-size: 16px;
            color: #026dd1;
            margin-right: 12px;
          }
        }
        .txt {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
        }
        .order_info_wrap {
          margin: 19px 0 45px;

          .order_info_content {
            background: #f0f0f0;
            border: 1px dashed #aaaaaa;
            padding: 20px 20px 30px;
            box-sizing: border-box;
            .order_info_head {
              margin-bottom: 14px;
              p {
                font-size: 18px;
                color: #333333;
                font-weight: bold;
              }
            }
            .order_info_body {
              h2 {
                font-size: 16px;
                color: #333333;
                font-weight: bold;
              }
              p {
                font-size: 16px;
                color: #333333;
                &:nth-child(2) {
                  margin: 10px 0;
                }
              }
            }
          }
        }
        .order_shop_wrap {
          .order_shop_content_list {
            margin-bottom: 20px;
            .order_shop_content_item {
              background: #f0f0f0;
              border: 1px dashed #aaaaaa;
              padding: 20px 20px 15px;
              box-sizing: border-box;
              margin-bottom: 10px;
              &:last-child {
                margin-bottom: 0;
              }
              .order_shop_head {
                margin-bottom: 8px;
                .order_shop_attr_num {
                  font-size: 16px;
                  color: #333333;
                  p {
                    margin-right: 20px;
                  }
                }
              }
              .order_shop_body {
                color: #333333;
                .name_tel {
                  margin-bottom: 10px;
                }
                h2 {
                  font-size: 16px;
                  font-weight: bold;
                  margin-right: 70px;
                }
                p {
                  font-size: 12px;
                }
              }
            }
          }
        }

        .operation_wrap {
          .icon-xiugai {
            font-size: 30px;
            color: #393939;
            cursor: pointer;
          }
          .icon-close {
            font-weight: bold;
            font-size: 26px;
            color: #393939;
            cursor: pointer;
            margin-left: 20px;
          }
        }
        .order_data_tit {
          font-size: 20px;
          color: #333333;
          font-weight: bold;
          margin-bottom: 18px;
        }
        .order_no_data_wrap {
          width: 50px;
          height: 50px;
          background: #f0f0f0;
          border: 1px dashed #aaaaaa;
          cursor: pointer;
          .icon-jiahao1 {
            font-size: 30px;
            color: #333333;
          }
        }
      }
    }
    .content_detail {
      width: 750px;
      background: #fff;
      padding: 40px 20px;
      box-sizing: border-box;
      margin: auto;
      .content_detail_list {
        .content_detail_item {
          width: 100%;
          .pic_box {
            width: 100%;
          }
          img,
          video {
            width: 100%;
          }
          .txt_box {
            font-size: 16px;
          }
        }
      }
    }
  }
  .btm_container {
    width: 100%;
    height: 100px;
    background: #fff;
    padding: 0 310px 0 280px;
    box-sizing: border-box;
    font-size: 18px;
    color: #666666;
    .left_btm {
      color: #333333;
      .left_btm_item {
        &:last-child {
          margin-left: 95px;
        }
      }
      .txt {
        font-size: 18px;
      }
      .num {
        font-size: 28px;
        span {
          font-size: 16px !important;
        }
      }
    }
    .right_btm {
      color: #666666;
      .txt {
        font-size: 18px;
        &.b {
          font-weight: bold;
        }
      }
      .unit {
        font-size: 16px;
      }
      .num {
        font-size: 36px;
        color: #333333;
        margin-left: 8px;
      }
      .right_btm_btn {
        margin-left: 90px;
        width: 190px;
        height: 50px;
        background: #1e1e1e;
        font-size: 20px;
        color: #fff;
        cursor: pointer;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 23px;
          font-size: 20px;
        }
        &.disabled {
          background: #c8c8c8;
        }
      }
    }
    .line {
      margin: 0 7px 0 12px;
      display: inline-block;
    }
    .mr_10 {
      margin-right: 10px;
    }
    .mr_20 {
      margin-right: 20px;
    }
  }
  .custom_dialog {
    .custom_dialog_container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -48%);
      width: 1060px;
      height: 70vh;
      background: #fff;
      .custom_dialog_close {
        position: absolute;
        right: 0;
        top: -35px;
        .icon-jujueweituo {
          font-size: 30px;
          color: #fff;
          cursor: pointer;
        }
      }
      .custom_dialog_head {
        padding: 30px 0 35px 25px;
        box-sizing: border-box;
        font-size: 18px;
        color: #333333;

        .custom_dialog_tit {
          position: relative;
          padding-right: 20px;
          box-sizing: border-box;
          cursor: pointer;
          &.active {
            font-weight: 800;
            &::after {
              position: absolute;
              width: 100%;
              height: 10px;
              content: "";
              background: #000000;
              bottom: -16px;
              left: 0;
            }
          }
        }
        .line {
          margin: 0 25px;
        }
      }
      .custom_dialog_body {
        height: calc(70vh - 132px);
        padding: 0 35px 0 25px;
        box-sizing: border-box;
        overflow-y: scroll;
        // 隐藏滚动条
        &::-webkit-scrollbar {
          display: none;
        }
        .address_dialog_body {
          height: 100%;
          .address_list {
            .address_item {
              width: 100%;
              // height: 110px;
              border: 1px solid #c8c8c8;
              font-size: 18px;
              margin-bottom: 10px;
              padding: 24px 20px 23px;
              box-sizing: border-box;
              opacity: 0.5;
              cursor: pointer;
              &:last-child {
                margin-bottom: 0;
              }
              &.active {
                opacity: 1;
              }
              .radio {
                width: 48px;
                flex-shrink: 0;
                .iconfont {
                  font-size: 34px;
                }
                .icon-danxuanyixuan1 {
                  color: #ea4e4e;
                  font-size: 30px;
                }
              }
              .address_content {
                align-items: flex-end;
                flex: 1;
                .address_content_item {
                  flex: 1;
                  color: #333333;
                  h1 {
                    font-weight: bold;
                    font-size: 18px;
                  }
                  p {
                    font-size: 16px;
                    &:nth-child(2) {
                      margin: 8px 0;
                    }
                  }
                }
              }
            }
          }
        }
        &.attr_dialog_body {
          overflow: hidden;
          height: calc(70vh - 152px);
          margin-bottom: 20px;
          align-items: flex-start;
          .custom_dialog_body_left {
            height: 90%;
            width: 370px;
            flex-shrink: 0;
            margin-right: 30px;
          }
          .custom_dialog_body_right {
            flex: 1;
            height: 100%;
            overflow-y: scroll;
            // 隐藏滚动条
            &::-webkit-scrollbar {
              display: none;
            }
            .custom_dialog_body_right_main {
              font-size: 16px;
              .tit {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 20px;
              }
              .attr_list {
                .attr_item {
                  .attrvalue_list {
                    flex-wrap: wrap;
                    .attrvalue_item {
                      height: 40px;
                      border: 1px solid #ececec;
                      background: #fafafa;
                      margin-bottom: 10px;
                      border-radius: 20px;
                      padding: 0 78px 0 5px;
                      box-sizing: border-box;
                      cursor: pointer;
                      margin-right: 10px;
                      position: relative;
                      .icon {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        margin-right: 11px;
                      }
                      .select_radio {
                        position: absolute;
                        right: 10px;
                        background: url("../../../assets/images/select_radio.png")
                          no-repeat center;
                        background-size: cover;
                        width: 21px;
                        height: 20px;
                      }
                      &.selected {
                        border: 1px solid #989898;
                      }
                      &.no_icon {
                        padding-left: 25px;
                      }
                    }
                  }
                }
              }
              .num_block {
                margin: 29px 0;
                .step_wrap {
                  height: 50px;
                  input {
                    border: 1px solid #d2d2d2;
                    height: 100%;
                    padding: 0 18px;
                    box-sizing: border-box;
                    width: 130px;
                    border-radius: 25px;
                  }
                  .icon-add-step {
                    width: 30px;
                    height: 30px;
                    background: url("../../../assets/images/icon-add-step.png")
                      no-repeat center;
                    background-size: cover;
                    margin: 0 10px;
                    cursor: pointer;
                  }
                  .icon-reduce-step {
                    width: 30px;
                    height: 30px;
                    background: url("../../../assets/images/icon-reduce-step.png")
                      no-repeat center;
                    background-size: cover;
                    cursor: pointer;
                  }
                }
              }
              .add_edit_block {
                .add_btn {
                  width: 100%;
                  height: 50px;
                  border: 1px dashed #aaaaaa;
                  background: #f0f0f0;
                  padding: 0 13px;
                  box-sizing: border-box;
                  cursor: pointer;
                  .icon-jiahao1 {
                    margin-right: 10px;
                    font-size: 20px;
                    color: #343434;
                    font-weight: bold;
                  }
                }
                .edit_block {
                  width: 100%;
                  padding: 20px 20px 18px 19px;
                  box-sizing: border-box;
                  background: #f0f0f0;
                  border: 1px dashed #aaaaaa;
                  font-size: 16px;
                  color: #333333;
                  align-items: flex-start;
                  .edit_block_main {
                    flex: 1;
                    h1 {
                      font-weight: bold;
                    }
                    p {
                      &:nth-child(2) {
                        margin: 8px 0 5px;
                      }
                    }
                  }
                  .edit_block_operation {
                    .icon-xiugai {
                      font-size: 24px;
                      color: #393939;
                      cursor: pointer;
                    }
                    .icon-close {
                      font-weight: bold;
                      font-size: 20px;
                      color: #393939;
                      cursor: pointer;
                      margin-left: 20px;
                    }
                  }
                }
              }
            }
            .custom_dialog_body_right_logistics {
              height: 95%;
              flex: 1;
              background: #f0f0f0;
              border: 1px dashed #aaaaaa;
              padding: 20px 20px 45px 12px;
              box-sizing: border-box;
              .logistics_head {
                color: #333;
                margin-bottom: 25px;
                .logistics_tit {
                  align-items: flex-end;
                  font-size: 16px;
                  margin-bottom: 20px;
                  .icon-close {
                    font-size: 22px;
                    font-weight: bold;
                  }
                }
                .logistics_subTit {
                  font-size: 18px;
                  color: #333333;
                  font-weight: bold;
                }
              }
              .logistics_body {
                height: calc(100% - 80px);
                overflow-y: scroll;
                // 隐藏滚动条
                &::-webkit-scrollbar {
                  display: none;
                }
                .address_list {
                  .address_item {
                    width: 100%;
                    background: #fff;
                    font-size: 18px;
                    margin-bottom: 10px;
                    padding: 24px 20px 23px 15px;
                    box-sizing: border-box;
                    opacity: 0.5;
                    cursor: pointer;
                    &:last-child {
                      margin-bottom: 0;
                    }
                    &.active {
                      opacity: 1;
                    }
                    .radio {
                      width: 48px;
                      flex-shrink: 0;
                      .iconfont {
                        font-size: 34px;
                      }
                      .icon-danxuanyixuan1 {
                        color: #ea4e4e;
                        font-size: 30px;
                      }
                    }
                    .address_content {
                      align-items: flex-end;
                      flex: 1;
                      .address_content_item {
                        flex: 1;
                        color: #333333;
                        h1 {
                          font-weight: bold;
                          font-size: 18px;
                        }
                        p {
                          font-size: 16px;
                          &:nth-child(2) {
                            margin: 8px 0;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .custom_dialog_footer {
        height: 50px;
        align-items: flex-end;
        .custom_dialog_footer_btn {
          height: 100%;
          width: 190px;
          background: #1e1e1e;
          font-size: 16px;
          color: #fff;
          position: relative;
          cursor: pointer;
          .icon-yuyinjiantou {
            position: absolute;
            right: 20px;
            transform: rotate(-90deg);
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>